import React, { useState } from 'react';
//import './navbar.css';
import { Link } from "react-router-dom"
import {  Row, Col, Table, ListGroup,Tooltip } from 'react-bootstrap';
import Nuovo_Alunno_Edit from "./Alunno_x0_Edit";
import Dropdown_Classi from "./Alunno_x2_cambio_classe";
import JSONPretty from 'react-json-pretty';
import Visualizza_lista_documenti_pdf from "../Funzioni_comuni_pdf_visualizza.jsx";

//const { Data_formattata } = require('../Funzioni_comuni')

 
 
const Lista_alunni = (props) => {
//    const [somma, calcola_somma] = useState('');
    const [opzione_sposta_alunno, SET_opzione_sposta_alunno] = useState(false);


    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Simple tooltip
        </Tooltip>
    );


    return (
        <div className='container'>
                <ListGroup>
                    {Array.isArray(props.lista_alunni) &&  props.lista_alunni.map(function (item, index2) {
                        {
                            //                        console.log(item)
                            return <div>
                                <Row>
                                    <Nuovo_Alunno_Edit alunno={item} tutor={props.tutor} 
                                                       SET_variab_aggiorna={props.SET_variab_aggiorna}
                                                       SET_opzione_sposta_alunno={SET_opzione_sposta_alunno} />
                                    
                                    {opzione_sposta_alunno &&
                                        <Dropdown_Classi alunno={item} 
                                                        lista_classi={props.lista_classi} 
                                                        SET_variab_aggiorna={props.SET_variab_aggiorna}/>
                                    }
                                </Row>
                                <Row>
                                    <Col>
                                        <ul>
                                            <li>Alunno: <b>{item.cognome}</b>  <strong>{item.nome}</strong></li>
                                            <li>Email: <strong>{item.email}</strong></li>
                                        </ul>

                                    </Col>

                                    <Col>
                                        <ul>
                                            <li>Email_gen1: <strong>{item.email_genitore1}</strong></li>
                                            <li>Email_gen2: <strong>{item.email_genitore2}</strong></li>
                                        </ul>

                                    </Col>

                                </Row>
                                {item.documentazione_array.length != 0 && <>             
                                    <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                        <th>#</th>
                                        <th>Tipologia</th>
                                        <th>Data Caricamento</th>
                                        
                                        <th>Tutor</th>
                                        <th>Admin</th>
                                
                                        <th>Azioni</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {/*------------------ AGGIORNARE MONGO QRCODE ---------------------------*/}   
            
                                    <Visualizza_lista_documenti_pdf attore_tipo= {'alunno'} attore={item} tutor={props.tutor} tipologia_documento={'formazione_A'} SET_variab_aggiorna={props.SET_variab_aggiorna}/> 
                                    <Visualizza_lista_documenti_pdf attore_tipo= {'alunno'} attore={item} tutor={props.tutor} tipologia_documento={'formazione_B'} SET_variab_aggiorna={props.SET_variab_aggiorna}/> 
                                    <Visualizza_lista_documenti_pdf attore_tipo= {'alunno'} attore={item} tutor={props.tutor} tipologia_documento={'formazione_C'} SET_variab_aggiorna={props.SET_variab_aggiorna}/> 

                                    </tbody>
                                </Table>
                                </> }
                                <hr class="rounded"></hr>
                                {(props.account_dati.utente_debug) &&
                                    
                                                <JSONPretty data={item} />
                                }
                            </div>
                        }
                    })
                    }
                </ListGroup>
            </div>
    )
}
export default Lista_alunni;